module.exports = __webpack_public_path__ + "assets/group-6@3x.d2bf96ba69bbfa2fada285d978422eb0.png";